var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "activity-template" },
    [
      _c(
        "el-tabs",
        {
          attrs: { type: "card", closable: "" },
          on: {
            "tab-click": _vm.handleTabClick,
            "tab-remove": _vm.handleTabRemove,
          },
          model: {
            value: _vm.activeTab,
            callback: function ($$v) {
              _vm.activeTab = $$v
            },
            expression: "activeTab",
          },
        },
        _vm._l(_vm.tabs, function (tab) {
          return _c(
            "el-tab-pane",
            {
              key: tab.name,
              attrs: {
                label: tab.label,
                name: tab.name,
                closable: tab.name !== "list",
              },
            },
            [
              _vm.activeTab === "list"
                ? _c("div", [
                    _c(
                      "div",
                      { staticClass: "search-area" },
                      [
                        _c(
                          "el-form",
                          {
                            staticClass: "search-form",
                            attrs: { inline: true, model: _vm.searchForm },
                          },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "手机号", prop: "phone" } },
                              [
                                _c("el-input", {
                                  attrs: {
                                    placeholder: "请输入手机号",
                                    clearable: "",
                                  },
                                  model: {
                                    value: _vm.searchForm.phone,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.searchForm, "phone", $$v)
                                    },
                                    expression: "searchForm.phone",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "用户昵称", prop: "alias" } },
                              [
                                _c("el-input", {
                                  attrs: {
                                    placeholder: "请输入用户昵称",
                                    clearable: "",
                                  },
                                  model: {
                                    value: _vm.searchForm.alias,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.searchForm, "alias", $$v)
                                    },
                                    expression: "searchForm.alias",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              {
                                attrs: { label: "时间范围", prop: "timeRange" },
                              },
                              [
                                _c("el-date-picker", {
                                  staticStyle: { width: "360px" },
                                  attrs: {
                                    type: "datetimerange",
                                    "range-separator": "至",
                                    "start-placeholder": "开始日期",
                                    "end-placeholder": "结束日期",
                                    "value-format": "yyyy-MM-dd HH:mm:ss",
                                  },
                                  model: {
                                    value: _vm.searchForm.timeRange,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.searchForm, "timeRange", $$v)
                                    },
                                    expression: "searchForm.timeRange",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "门店", prop: "shopId" } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "160px" },
                                    attrs: {
                                      placeholder: "请选择门店",
                                      clearable: "",
                                    },
                                    model: {
                                      value: _vm.searchForm.shopId,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.searchForm, "shopId", $$v)
                                      },
                                      expression: "searchForm.shopId",
                                    },
                                  },
                                  _vm._l(_vm.shopList, function (shop) {
                                    return _c("el-option", {
                                      key: shop.value,
                                      attrs: {
                                        label: shop.label,
                                        value: shop.value,
                                      },
                                    })
                                  }),
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "等级", prop: "gradeId" } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "160px" },
                                    attrs: {
                                      placeholder: "请选择等级",
                                      clearable: "",
                                    },
                                    model: {
                                      value: _vm.searchForm.gradeId,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.searchForm, "gradeId", $$v)
                                      },
                                      expression: "searchForm.gradeId",
                                    },
                                  },
                                  _vm._l(_vm.gradeList, function (grade) {
                                    return _c("el-option", {
                                      key: grade.id,
                                      attrs: {
                                        label: grade.gradeName,
                                        value: grade.id,
                                      },
                                    })
                                  }),
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              {
                                attrs: { label: "是否推荐", prop: "recommend" },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: {
                                      placeholder: "是否推荐",
                                      clearable: "",
                                    },
                                    model: {
                                      value: _vm.searchForm.recommend,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.searchForm,
                                          "recommend",
                                          $$v
                                        )
                                      },
                                      expression: "searchForm.recommend",
                                    },
                                  },
                                  [
                                    _c("el-option", {
                                      attrs: { label: "是", value: "1" },
                                    }),
                                    _vm._v(" "),
                                    _c("el-option", {
                                      attrs: { label: "否", value: "0" },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "话题内容",
                                  prop: "topicMessage",
                                },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: {
                                      placeholder: "请选择话题",
                                      clearable: "",
                                      filterable: "",
                                    },
                                    model: {
                                      value: _vm.searchForm.topicMessage,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.searchForm,
                                          "topicMessage",
                                          $$v
                                        )
                                      },
                                      expression: "searchForm.topicMessage",
                                    },
                                  },
                                  _vm._l(_vm.topicList, function (topic) {
                                    return _c("el-option", {
                                      key: topic.id,
                                      attrs: {
                                        label: topic.title,
                                        value: topic.title,
                                      },
                                    })
                                  }),
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "消息内容",
                                  prop: "contentMessage",
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    placeholder: "请输入消息内容",
                                    clearable: "",
                                  },
                                  model: {
                                    value: _vm.searchForm.contentMessage,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.searchForm,
                                        "contentMessage",
                                        $$v
                                      )
                                    },
                                    expression: "searchForm.contentMessage",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "primary" },
                                    on: { click: _vm.handleSearch },
                                  },
                                  [_vm._v("搜索")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "primary" },
                                    on: { click: _vm.handleAdd },
                                  },
                                  [_vm._v("新增")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-button",
                                  {
                                    staticStyle: { "margin-left": "10px" },
                                    attrs: {
                                      type: "primary",
                                      loading: _vm.exportLoading,
                                    },
                                    on: { click: _vm.handleExport },
                                  },
                                  [
                                    _vm._v(
                                      "\n                导出\n              "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "radio-area" },
                      [
                        _c(
                          "el-radio-group",
                          {
                            on: { change: _vm.handleTabChange },
                            model: {
                              value: _vm.searchForm.type,
                              callback: function ($$v) {
                                _vm.$set(_vm.searchForm, "type", $$v)
                              },
                              expression: "searchForm.type",
                            },
                          },
                          [
                            _c("el-radio-button", { attrs: { label: 0 } }, [
                              _vm._v("广场"),
                            ]),
                            _vm._v(" "),
                            _c("el-radio-button", { attrs: { label: 3 } }, [
                              _vm._v("打标"),
                            ]),
                            _vm._v(" "),
                            _c("el-radio-button", { attrs: { label: 4 } }, [
                              _vm._v("上墙"),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "table-area" },
                      [
                        _c(
                          "el-table",
                          {
                            directives: [
                              {
                                name: "loading",
                                rawName: "v-loading",
                                value: _vm.tableLoading,
                                expression: "tableLoading",
                              },
                            ],
                            staticClass: "fixed-height-table",
                            staticStyle: { width: "100%" },
                            attrs: {
                              data: _vm.tableData,
                              border: "",
                              height: "500px",
                            },
                            on: {
                              "selection-change": _vm.handleSelectionChange,
                            },
                          },
                          [
                            _c("el-table-column", {
                              attrs: {
                                prop: "id",
                                label: "编号",
                                align: "center",
                                "min-width": "80",
                              },
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "alias",
                                label: "别名",
                                align: "center",
                                "min-width": "280",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "user-info-container",
                                          },
                                          [
                                            scope.row.isMuted
                                              ? _c(
                                                  "el-button",
                                                  {
                                                    staticClass:
                                                      "banned-button",
                                                    attrs: {
                                                      type: "danger",
                                                      size: "mini",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                    禁言\n                  "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              { staticClass: "user-name" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    scope.row.alias ||
                                                      "匿名用户"
                                                  )
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            scope.row.mobilePhone
                                              ? _c(
                                                  "span",
                                                  { staticClass: "user-name" },
                                                  [
                                                    _vm._v(
                                                      "（" +
                                                        _vm._s(
                                                          scope.row.mobilePhone
                                                        ) +
                                                        "）"
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "gradeName",
                                label: "等级",
                                align: "center",
                                "min-width": "100",
                              },
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "shopId",
                                label: "门店",
                                align: "center",
                                "min-width": "100",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.getShopName(scope.row.shopId)
                                            ) +
                                            "\n              "
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "title",
                                label: "标题",
                                align: "center",
                                "min-width": "100",
                              },
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "content",
                                label: "动态内容",
                                align: "left",
                                "min-width": "200",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "div",
                                          { staticClass: "content-preview" },
                                          [_vm._v(_vm._s(scope.row.content))]
                                        ),
                                        _vm._v(" "),
                                        scope.row.images &&
                                        scope.row.images.length > 0
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "images-container",
                                              },
                                              _vm._l(
                                                scope.row.images,
                                                function (img, index) {
                                                  return _c("el-image", {
                                                    key: index,
                                                    staticClass:
                                                      "content-image",
                                                    attrs: {
                                                      src: _vm.getImageUrl(img),
                                                      "preview-src-list":
                                                        scope.row.images.map(
                                                          _vm.getImageUrl
                                                        ),
                                                      fit: "cover",
                                                    },
                                                  })
                                                }
                                              ),
                                              1
                                            )
                                          : _vm._e(),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "addTime",
                                label: "发布时间",
                                align: "center",
                                "min-width": "180",
                              },
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "praiseNum",
                                label: "点赞数",
                                align: "center",
                                "min-width": "100",
                              },
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "replyNum",
                                label: "评论数",
                                align: "center",
                                "min-width": "100",
                              },
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "isTop",
                                label: "打标",
                                align: "center",
                                "min-width": "100",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-button",
                                          {
                                            staticClass: "status-button",
                                            class: {
                                              "is-active": scope.row.isTop > 0,
                                            },
                                            attrs: {
                                              type: _vm.getIsTopButtonType(
                                                scope.row.isTop
                                              ),
                                              size: "mini",
                                              disabled: scope.row.isTop !== 0,
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.handleIsTopClick(
                                                  scope.row
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  _vm.getIsTopDisplayName(
                                                    scope.row.isTop
                                                  )
                                                ) +
                                                "\n                "
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "ordno",
                                label: "序号",
                                align: "center",
                                "min-width": "100",
                              },
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "isTj",
                                label: "广场",
                                align: "center",
                                "min-width": "100",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-tag",
                                          {
                                            staticStyle: { cursor: "pointer" },
                                            attrs: {
                                              type:
                                                scope.row.isTj === true
                                                  ? "success"
                                                  : "info",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.handleAuditOrRecommend(
                                                  scope.row,
                                                  1
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  scope.row.isTj === true
                                                    ? "是"
                                                    : "否"
                                                ) +
                                                "\n                "
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "status",
                                label: "审核",
                                align: "center",
                                "min-width": "100",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-tag",
                                          {
                                            staticStyle: { cursor: "pointer" },
                                            attrs: {
                                              type:
                                                scope.row.status === 1
                                                  ? "success"
                                                  : "info",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.handleAuditOrRecommend(
                                                  scope.row,
                                                  2
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  scope.row.status === 1
                                                    ? "是"
                                                    : "否"
                                                ) +
                                                "\n                "
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "applyStatus",
                                label: "上墙评审状态",
                                align: "center",
                                "min-width": "120",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        scope.row.applyStatus === 0
                                          ? _c("el-tag", [_vm._v("待申请")])
                                          : scope.row.applyStatus === 1
                                          ? _c(
                                              "el-tag",
                                              { attrs: { type: "warning" } },
                                              [_vm._v("待审核")]
                                            )
                                          : scope.row.applyStatus === 2
                                          ? _c(
                                              "el-tag",
                                              { attrs: { type: "danger" } },
                                              [_vm._v("社长驳回")]
                                            )
                                          : scope.row.applyStatus === 3
                                          ? _c(
                                              "el-tag",
                                              { attrs: { type: "info" } },
                                              [_vm._v("投票中")]
                                            )
                                          : scope.row.applyStatus === 4
                                          ? _c(
                                              "el-tag",
                                              { attrs: { type: "success" } },
                                              [_vm._v("上墙成功")]
                                            )
                                          : scope.row.applyStatus === 5
                                          ? _c(
                                              "el-tag",
                                              { attrs: { type: "danger" } },
                                              [_vm._v("上墙失败")]
                                            )
                                          : _c("span", [_vm._v("-")]),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                label: "操作",
                                align: "center",
                                "min-width": "220",
                                fixed: "right",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-button",
                                          {
                                            attrs: { size: "mini" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.handleRemove(
                                                  scope.row
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                  移除\n                "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              size: "mini",
                                              type: "success",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.handleViewDetail(
                                                  scope.row
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                  查看\n                "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              size: "mini",
                                              type: "danger",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.handleDelete(
                                                  scope.row
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("禁言")]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "pagination-area" },
                      [
                        _c("el-pagination", {
                          attrs: {
                            "current-page": _vm.currentPage,
                            "page-sizes": [10, 20, 50, 100],
                            "page-size": _vm.pageSize,
                            layout: "total, sizes, prev, pager, next, jumper",
                            total: _vm.total,
                          },
                          on: {
                            "size-change": _vm.handleSizeChange,
                            "current-change": _vm.handleCurrentChange,
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.dialogVisible
                      ? _c(
                          "div",
                          [
                            _c(
                              "el-dialog",
                              {
                                staticClass: "tagging-dialog",
                                attrs: {
                                  title: "打标",
                                  visible: _vm.dialogVisible,
                                  width: "500px",
                                  "before-close": _vm.handleDialogClose,
                                },
                                on: {
                                  "update:visible": function ($event) {
                                    _vm.dialogVisible = $event
                                  },
                                },
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "dialog-content" },
                                  [
                                    _c(
                                      "el-form",
                                      {
                                        attrs: {
                                          model: _vm.dialogForm,
                                          "label-width": "80px",
                                        },
                                      },
                                      [
                                        _c(
                                          "el-form-item",
                                          { attrs: { label: "打标类型" } },
                                          [
                                            _c(
                                              "el-radio-group",
                                              {
                                                model: {
                                                  value: _vm.dialogForm.isTop,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.dialogForm,
                                                      "isTop",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "dialogForm.isTop",
                                                },
                                              },
                                              [
                                                _c(
                                                  "el-radio",
                                                  { attrs: { label: 0 } },
                                                  [_vm._v("无")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "el-radio",
                                                  { attrs: { label: 1 } },
                                                  [_vm._v("置顶")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "el-radio",
                                                  { attrs: { label: 2 } },
                                                  [_vm._v("广告")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "el-radio",
                                                  { attrs: { label: 3 } },
                                                  [_vm._v("官方")]
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _vm.dialogForm.isTop != 0
                                          ? _c(
                                              "el-form-item",
                                              { attrs: { label: "时间范围" } },
                                              [
                                                _c("el-date-picker", {
                                                  staticStyle: {
                                                    width: "100%",
                                                  },
                                                  attrs: {
                                                    type: "datetimerange",
                                                    "range-separator": "至",
                                                    "start-placeholder":
                                                      "开始时间",
                                                    "end-placeholder":
                                                      "结束时间",
                                                    "value-format":
                                                      "yyyy-MM-dd HH:mm:ss",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.dialogForm.timeRange,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.dialogForm,
                                                        "timeRange",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "dialogForm.timeRange",
                                                  },
                                                }),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.dialogForm.isTop != 0
                                          ? _c(
                                              "el-form-item",
                                              { attrs: { label: "序号" } },
                                              [
                                                _c("el-input", {
                                                  attrs: {
                                                    placeholder: "请输入序号",
                                                    clearable: "",
                                                  },
                                                  model: {
                                                    value: _vm.dialogForm.ordno,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.dialogForm,
                                                        "ordno",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "dialogForm.ordno",
                                                  },
                                                }),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.dialogForm.isTop === 2
                                          ? _c(
                                              "el-form-item",
                                              { attrs: { label: "广告ID" } },
                                              [
                                                _c("el-input", {
                                                  attrs: {
                                                    placeholder:
                                                      "请输入广告ID(* 指向推荐ID)",
                                                    clearable: "",
                                                  },
                                                  model: {
                                                    value: _vm.dialogForm.adv,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.dialogForm,
                                                        "adv",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "dialogForm.adv",
                                                  },
                                                }),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass: "dialog-footer",
                                    attrs: { slot: "footer" },
                                    slot: "footer",
                                  },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        on: {
                                          click: function ($event) {
                                            _vm.dialogVisible = false
                                          },
                                        },
                                      },
                                      [_vm._v("取消")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "primary" },
                                        on: { click: _vm.handleSaveTagging },
                                      },
                                      [_vm._v("保存")]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.banDialogVisible
                      ? _c(
                          "div",
                          [
                            _c(
                              "el-dialog",
                              {
                                staticClass: "ban-dialog",
                                attrs: {
                                  title: "禁言",
                                  visible: _vm.banDialogVisible,
                                  width: "500px",
                                },
                                on: {
                                  "update:visible": function ($event) {
                                    _vm.banDialogVisible = $event
                                  },
                                },
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "dialog-content" },
                                  [
                                    _c(
                                      "el-form",
                                      {
                                        attrs: {
                                          model: _vm.banForm,
                                          "label-width": "100px",
                                        },
                                      },
                                      [
                                        _c(
                                          "el-form-item",
                                          { attrs: { label: "用户手机号" } },
                                          [
                                            _c("el-input", {
                                              attrs: { disabled: "" },
                                              model: {
                                                value: _vm.banForm.mobilePhone,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.banForm,
                                                    "mobilePhone",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "banForm.mobilePhone",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-form-item",
                                          { attrs: { label: "禁言时间" } },
                                          [
                                            _c("el-date-picker", {
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                type: "datetimerange",
                                                "range-separator": "至",
                                                "start-placeholder": "开始时间",
                                                "end-placeholder": "结束时间",
                                                "value-format":
                                                  "yyyy-MM-dd HH:mm:ss",
                                              },
                                              model: {
                                                value: _vm.banForm.timeRange,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.banForm,
                                                    "timeRange",
                                                    $$v
                                                  )
                                                },
                                                expression: "banForm.timeRange",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-form-item",
                                          { attrs: { label: "备注" } },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                type: "textarea",
                                                placeholder: "请输入备注信息",
                                                rows: 3,
                                                clearable: "",
                                              },
                                              model: {
                                                value: _vm.banForm.reason,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.banForm,
                                                    "reason",
                                                    $$v
                                                  )
                                                },
                                                expression: "banForm.reason",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass: "dialog-footer",
                                    attrs: { slot: "footer" },
                                    slot: "footer",
                                  },
                                  [
                                    _c(
                                      "el-button",
                                      { on: { click: _vm.handleCancelBan } },
                                      [_vm._v("取消")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "primary" },
                                        on: { click: _vm.handleSaveBan },
                                      },
                                      [_vm._v("保存")]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ])
                : _vm.activeTab.startsWith("detail_")
                ? _c(
                    "div",
                    [
                      _c("community-dynamics-detail", {
                        attrs: {
                          "detail-data": _vm.getCurrentTabData(),
                          type: "detail",
                        },
                        on: {
                          "go-back": function ($event) {
                            return _vm.handleTabRemove(_vm.activeTab)
                          },
                        },
                      }),
                    ],
                    1
                  )
                : _vm.activeTab === "create_activity_template"
                ? _c(
                    "div",
                    [
                      _c("create-activity-template", {
                        on: {
                          "go-back": function () {
                            return _vm.handleTabRemove(
                              "create_activity_template"
                            )
                          },
                          "refresh-data": _vm.fetchData,
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }